import { styled } from '@material-ui/core/styles';
import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded';
import { FPActionButton } from 'UI/components/atoms';

const ICON_SIZE = 16;

export const ArrowForwardIcon = styled(ArrowForwardIosRoundedIcon)({
  height: ICON_SIZE,
  width: ICON_SIZE
});

export const OutlinedButtonStyled = styled(FPActionButton)({
  maxWidth: 'unset'
});
